<div class="toast" 
  [@toastAnimation]="toast.state" 
  (@toastAnimation.start)="onAnimationStart($event)"
  (@toastAnimation.done)="onAnimationDone($event)" 
  [ngClass]="toast.type">
  <div class="toast-content flex items-center gap-2">
    <ng-lottie *ngIf="toast.type === 'success'" [options]="optionsSuccess" width="60px" height="60px"></ng-lottie>
    <ng-lottie *ngIf="toast.type === 'error'" [options]="optionsFailed" width="60px" height="60px"></ng-lottie>
    <ng-lottie *ngIf="toast.type === 'welcome'" [options]="optionsWelcome" width="60px" height="60px"></ng-lottie>
    <div class="flex-1">
      <div class="toast-header">      
        <span class="toast-title text-sm">{{toast.title}}</span>
      </div>
      <div class="toast-message text-xs">{{toast.message}}</div>
    </div>
    <button class="toast-close" (click)="onCloseClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-progress-bar 
    *ngIf="toast.duration && toast.duration > 0"
    [value]="getProgressValue()"
    mode="determinate"
    class="toast-progress-bar">
  </mat-progress-bar>
</div> 